import { IAppState } from '../../redux';
import { selectActiveService } from '../publishTerms';

export function selectIsAutobrokerEnabled(state: IAppState): boolean {
  const {
    auction: {
      strategy: { isEnabled, serviceTypes },
    },
  } = state;

  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return false;
  }

  const { services } = selectedService;

  const isAutobrokerCompatible = services.some(serviceType => serviceTypes.includes(serviceType));

  return isEnabled && isAutobrokerCompatible;
}
